import { render, staticRenderFns } from "./ImgBackground.vue?vue&type=template&id=7602453e&scoped=true&"
import script from "./ImgBackground.vue?vue&type=script&lang=js&"
export * from "./ImgBackground.vue?vue&type=script&lang=js&"
import style0 from "./ImgBackground.vue?vue&type=style&index=0&id=7602453e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7602453e",
  null
  
)

export default component.exports